import React from 'react';
import { SearchCard } from '../types';
import { BaseResponsiveSearchCard } from '../Base';
import {
  Price,
  GrayUIText,
  Title,
  BlackUIText,
  UnitPriceText,
  ReserveBarTimerWrapper,
  GrayPrice,
  BottomContent,
} from '../Base/styles';
import styled from 'styled-components';
import { theme } from '../../../../theme';
import { BoxConditionIcon, TruckIcon, MapMarkerIcon } from '../../../../assets';
import { ReserveBar } from '../../../reserveBar';
import { Timer } from '../../../timer';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  margin: ${theme.spacings[2].rem};
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
`;

const StyledPrice = styled(Price)`
  ${theme.typography.headings[6]['sm-lg']};
`;

export const WineAuctionResponsiveSearchCard: React.FC<
  SearchCard<'WineAuction'>
> = ({
  title,
  reserveStatus,
  reserveStatusMapping,
  enforceReserve,
  condition,
  location,
  isDelivery,
  grayPrice,
  data,
  type,
  timeLeft,
  ...props
}) => {
  return (
    <BaseResponsiveSearchCard {...props}>
      <Content>
        <Title>{title}</Title>
        <ReserveBarTimerWrapper>
          {reserveStatus && (
            <ReserveBar
              reserveStatus={reserveStatus}
              reserveStatusMapping={reserveStatusMapping}
            />
          )}
          <Timer format="short" closingTime={timeLeft} />
        </ReserveBarTimerWrapper>
        <div>
          {grayPrice && <GrayPrice>{grayPrice}</GrayPrice>}
          <Container>
            <div>
              <StyledPrice>{data.perBottlePrice}</StyledPrice>
              <BlackUIText>
                <UnitPriceText>Per {data.unitPricing.unitName}</UnitPriceText>
              </BlackUIText>
            </div>
            <div>
              <StyledPrice>{data.secondaryPrice.price}</StyledPrice>
              <BlackUIText>
                <UnitPriceText>
                  Per {data.unitPricing.unitCollectiveNoun}{' '}
                </UnitPriceText>
              </BlackUIText>
            </div>
          </Container>
        </div>
        <BottomContent>
          <GrayUIText>
            <BoxConditionIcon
              width={16}
              fill={theme.colors.neutrals.solidGrays[3]}
            />
            {condition}
          </GrayUIText>
          <GrayUIText>
            {isDelivery ? (
              (condition as string).length < 15 && (
                <>
                  <TruckIcon
                    width={16}
                    fill={theme.colors.neutrals.solidGrays[3]}
                  />
                  Delivery
                </>
              )
            ) : (
              <>
                <MapMarkerIcon
                  width={16}
                  fill={theme.colors.neutrals.solidGrays[3]}
                />
                {location}
              </>
            )}
          </GrayUIText>
        </BottomContent>
      </Content>
    </BaseResponsiveSearchCard>
  );
};
